import type {
  ICockpitDocumentsGroupedProps,
  IDocumentGroup,
  TDocumentsGrouping,
  TDocumentType,
} from '../../types'
import { PartnerDocumentsSection } from '../partnerDocumentsSection/PartnerDocumentsSection'

import styles from './DocumentsGroupedDetail.module.scss'

interface IProps extends Pick<ICockpitDocumentsGroupedProps, 'readOnly'> {
  group: IDocumentGroup
  grouping: TDocumentsGrouping
  documentType: TDocumentType | null
}
export const DocumentsGroupedDetail = ({ group, grouping, documentType, readOnly }: IProps) => (
  <div className={styles.sections}>
    {group.sections.map((section) => (
      <PartnerDocumentsSection
        key={section.partnerId}
        section={section}
        readOnly={readOnly}
        showHeader={grouping !== 'partner'}
        showLinks={false}
        documentType={documentType ?? undefined}
        showCreateControls={grouping !== 'creator'}
      />
    ))}
  </div>
)
